import { getMailCategories } from '@/API/repositories/mailCategory';
import { getPromotions } from '@/API/repositories/promotion';
import { getToday } from '@/common/functions/getToday';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useEffect, useRef, useState } from 'react';
import { MAIL_TYPES } from '../constants/mailTypes';

const useSearchBox = (handleSearchCallback) => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const today = getToday();
	const isLoading =
		hasUnfilledRequest(getMailCategories) || hasUnfilledRequest(getPromotions);

	const [mailCategories, setMailCategories] = useState([]);
	const [promotions, setPromotions] = useState([]);
	const [selectedMailType, setSelectedMailType] = useState();
	const [mailOptions, setMailOptions] = useState([]);
	const [selectedMailOptions, setSelectedMailOptions] = useState([]);

	const dateFromRef = useRef();
	const dateToRef = useRef();

	const fetchOptions = async () => {
		const mailCategoriesResponse = await makeRequest(getMailCategories);
		const promotionsResponse = await makeRequest(getPromotions);

		const mailCategoriesData = mailCategoriesResponse.data
			.sort((a, b) => a.name.localeCompare(b.name))
			.map((mail) => ({ label: mail.name, value: mail._id }));

		const promotionsData = promotionsResponse.data.map((promotion) => ({
			label: promotion.name,
			value: promotion._id,
		}));

		setMailCategories(mailCategoriesData);
		setPromotions(promotionsData);
	};

	const handleMailTypeChange = (mailType) => {
		switch (MAIL_TYPES[mailType]) {
			case MAIL_TYPES.PROMOTION:
				setMailOptions(promotions);
				break;
			default:
				setMailOptions(mailCategories);
		}
		setSelectedMailOptions([]);
	};

	const handleSearch = () => {
		if (selectedMailOptions.length < 1) {
			return addMessage('Select mailing name');
		}

		const dateFrom = new Date(dateFromRef.current.value).toISOString();
		const dateTo = new Date(dateToRef.current.value).toISOString();
		const mailNameIds = selectedMailOptions.map((mt) => mt.value);

		handleSearchCallback({
			mailingType: selectedMailType.label,
			dateFrom,
			dateTo,
			mailNameIds,
		});
	};

	useEffect(() => {
		fetchOptions();
	}, []);

	return {
		today,
		mailCategories,
		dateFromRef,
		dateToRef,
		handleSearch,
		selectedMailType,
		setSelectedMailType,
		mailOptions,
		selectedMailOptions,
		setSelectedMailOptions,
		handleMailTypeChange,
		isLoading,
	};
};

export default useSearchBox;
